import {
  setHomeBalance,
  setBankBalance,
  setPdfFile,
  setPdfTitle,
  setPwaConfigData,
  setAssetsData,
  setAssetsLoadingData
} from "./slice";

export const setActionHomeBalance = (data) => (dispatch) => {
  dispatch(setHomeBalance(data));
};

export const setActionBankBalance = (data) => (dispatch) => {
  dispatch(setBankBalance(data));
};

export const setActionPdfFile = (data) => (dispatch) => {
  dispatch(setPdfFile(data));
};

export const setActionPdfTitle = (data) => (dispatch) => {
  dispatch(setPdfTitle(data));
};

export const setPwaConfig = (data) => (dispatch) => {
  dispatch(setPwaConfigData(data));
};

export const setAssets = (data) => (dispatch) => {
  dispatch(setAssetsData(data));
};

export const setAssetsLoading = (data) => (dispatch) => {
  dispatch(setAssetsLoadingData(data));
};